import Development from "pages/Development";
import { RouterLinksInterface, HandleInterface, Route } from "./types";

export const addHandlesToRoutes = (routerLinks: RouterLinksInterface) => {
  const addHandles = ({
    routes,
    depth = 0,
    pathIn = "",
  }: {
    routes: Route[];
    depth?: number;
    pathIn?: string;
  }): { processedRoutes: Route[] } => {
    return routes.reduce<{ processedRoutes: Route[] }>(
      ({ processedRoutes }, { children, ...route }) => {
        const { processedRoutes: childRoutesPre } = addHandles({
          routes: children ?? [],
          depth: depth + 1,
          pathIn: pathIn + route.path,
        });
        if (route.linkId) {
          routerLinks[route.linkId] = { label: route.label, path: pathIn + "/" + route.path };
        }
        const element = route.element ?? <Development label={route.label} />;

        // If the route already defines explicit childLinks in its handle, use those.
        // Otherwise auto-generate from child routes (skip for menuSection routes
        // that don't define their own childLinks).
        const childLinks = route.handle?.childLinks
          ? route.handle.childLinks
          : route.menuSection
          ? []
          : childRoutesPre.reduce<{ label: string; To: string }[]>((childRoutes, { label, path }) => {
              if ((path ?? "").startsWith(":")) return childRoutes;
              return childRoutes.concat({ label, To: path });
            }, []);

        const handle: HandleInterface = {
          ...route.handle,
          isIndex: route.index ?? false,
          label: route.addBreadcrumb === false ? undefined : route.handle?.label ?? route.label,
          pageTitle: route.handle?.pageTitle ?? route.label,
          childLinks: route.handle?.childLinks ?? childLinks,
          layout: route.layout,
          hideTabs: route.handle?.hideTabs ?? false,
        };

        return {
          processedRoutes: processedRoutes.concat({
            element,
            ...route,
            handle,
            children: childRoutesPre.length ? childRoutesPre : undefined,
          }),
        };
      },
      { processedRoutes: [] }
    );
  };
  return addHandles;
};
